// Footer.jsx
import React from "react";
import "./Footer.css";
import { mockCompanyData, mockContactInfo } from "./mock";
import ABS from "../../../assets/logo.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footers">
      <div className="footer-containers">
        <div className="footer-grid">
          {/* Company Info */}

          <div className="footer-col footer-company">
          <img className="logo" src={ABS} alt="logo" />
            <div className="footer-logo">
              <span className="footer-logo-text">{mockCompanyData.name}</span>
            </div>
            <p className="footer-description">{mockCompanyData.description}</p>
            <p className="footer-copyright">
              © {currentYear} {mockCompanyData.name}. All rights reserved.
            </p>
          </div>

          {/* Services */}
          <div className="footer-col">
            <h4 className="footer-heading">Our Services</h4>
            <ul className="footer-links">
              <li>
                <a href="#">IT Helpdesk Support</a>
              </li>
              <li>
                <a href="#">Software Support</a>
              </li>
              <li>
                <a href="#">Hardware Repair</a>
              </li>
              <li>
                <a href="#">Tech Consulting</a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-col">
            <h4 className="footer-heading">Contact Info</h4>
            <div className="footer-contact">
              <div>
                <p className="footer-contact-label">Phone</p>
                <a href={`tel:${mockContactInfo.phone}`}>
                  {mockContactInfo.phone}
                </a>
              </div>
              <div>
                <p className="footer-contact-label">Email</p>
                <a href={`mailto:${mockContactInfo.email}`}>
                  {mockContactInfo.email}
                </a>
              </div>
              <div>
                <p className="footer-contact-label">Address</p>
                <p>{mockContactInfo.address}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            &copy; Copyright 2025 <span className="bold">Ambronex</span>. All
            Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
